import ajax from './../ajax';

export function getCompaniesMentors() {
  return ajax('/company_mentors', {
    method: 'GET'
  });
}



// WEBPACK FOOTER //
// ./src/api/v1/companiesMentors.js